import angular from 'angular';
const fg = angular.module('fg');

// add all .html to templateCache
fg.run([
  '$templateCache',
  function ($templateCache) {
    $templateCache.put(
      'angular-form-gen/form/form-fields/form-fields.ng.html',
      require('./form/form-fields/form-fields.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/edit/canvas/field/fg-edit-canvas-field.ng.html',
      require('./edit/canvas/field/fg-edit-canvas-field.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/edit/canvas/field/subfield-visibility/subfield-visibility.ng.html',
      require('./edit/canvas/field/subfield-visibility/subfield-visibility.ng.html')
        .default
    );

    $templateCache.put(
      'angular-form-gen/form/field/field.ng.html',
      require('./form/field/field.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/validation/summary.ng.html',
      require('./validation/summary.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/signature.ng.html',
      require('./field-templates/default/signature.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/number.ng.html',
      require('./field-templates/default/number.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/image.ng.html',
      require('./field-templates/default/image.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/not-in-cache.ng.html',
      require('./field-templates/default/not-in-cache.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/currency.ng.html',
      require('./field-templates/default/currency.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/text.ng.html',
      require('./field-templates/default/text.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/textarea.ng.html',
      require('./field-templates/default/textarea.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/email.ng.html',
      require('./field-templates/default/email.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/password.ng.html',
      require('./field-templates/default/password.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/checkbox.ng.html',
      require('./field-templates/default/checkbox.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/tasklist.ng.html',
      require('./field-templates/default/tasklist.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/multiselectlist.ng.html',
      require('./field-templates/default/multiselectlist.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/selectlist.ng.html',
      require('./field-templates/default/selectlist.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/radiobuttonlist.ng.html',
      require('./field-templates/default/radiobuttonlist.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/recaptcha.ng.html',
      require('./field-templates/default/recaptcha.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/approvalrule.ng.html',
      require('./field-templates/default/approvalrule.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/approvalcomment.ng.html',
      require('./field-templates/default/approvalcomment.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/submit.ng.html',
      require('./field-templates/default/submit.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/instruction.ng.html',
      require('./field-templates/default/instruction.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/date.ng.html',
      require('./field-templates/default/date.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/datetime.ng.html',
      require('./field-templates/default/datetime.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/lookup.ng.html',
      require('./field-templates/default/lookup.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/formula.ng.html',
      require('./field-templates/default/formula.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/address.ng.html',
      require('./field-templates/default/address.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/externalbusiness.ng.html',
      require('./field-templates/default/externalbusiness.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/form/files/image.ng.html',
      require('./form/files/image.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/common/jsonify/jsonify.ng.html',
      require('./common/jsonify/jsonify.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/common/tabs/tabs.ng.html',
      require('./common/tabs/tabs.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/common/tabs/tabs-pane.ng.html',
      require('./common/tabs/tabs-pane.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/edit/canvas/dropzone/dropzone.ng.html',
      require('./edit/canvas/dropzone/dropzone.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/edit/canvas/field/properties/properties.ng.html',
      require('./edit/canvas/field/properties/properties.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/edit/canvas/field/properties/options/options.ng.html',
      require('./edit/canvas/field/properties/options/options.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/edit/canvas/field/properties/property-field/common.ng.html',
      require('./edit/canvas/field/properties/property-field/common.ng.html')
        .default
    );

    $templateCache.put(
      'angular-form-gen/edit/canvas/field/properties/property-field/field-value.ng.html',
      require('./edit/canvas/field/properties/property-field/field-value.ng.html')
        .default
    );

    $templateCache.put(
      'angular-form-gen/edit/canvas/field/properties/property-field/property-field.ng.html',
      require('./edit/canvas/field/properties/property-field/property-field.ng.html')
        .default
    );

    $templateCache.put(
      'angular-form-gen/edit/canvas/field/properties/validation/validation.ng.html',
      require('./edit/canvas/field/properties/validation/validation.ng.html')
        .default
    );

    $templateCache.put(
      'angular-form-gen/edit/canvas/field/properties/validation/validation-message.ng.html',
      require('./edit/canvas/field/properties/validation/validation-message.ng.html')
        .default
    );

    $templateCache.put(
      'angular-form-gen/field-icon/field-icon.ng.html',
      require('./field-icon/field-icon.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/attachdocument.ng.html',
      require('./field-templates/default/attachdocument.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/dropdownlist.ng.html',
      require('./field-templates/default/dropdownlist.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/fileupload.ng.html',
      require('./field-templates/default/fileupload.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/procedure.ng.html',
      require('./field-templates/default/procedure.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/form/field/fieldPalette.ng.html',
      require('./form/field/fieldPalette.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/default/table.ng.html',
      require('./field-templates/default/table.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/form/files/image.selector.ng.html',
      require('./form/files/image.selector.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/form/files/file.confirmDelete.ng.html',
      require('./form/files/file.confirmDelete.ng.html').default
    );

    $templateCache.put(
      'angular-form-gen/field-templates/properties/approvalcomment.html',
      require('./field-templates/properties/approvalcomment.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/approvalrule.ng.html',
      require('./field-templates/properties/approvalrule.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/attachdocument.ng.html',
      require('./field-templates/properties/attachdocument.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/checkbox.ng.html',
      require('./field-templates/properties/checkbox.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/currency.ng.html',
      require('./field-templates/properties/currency.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/date.ng.html',
      require('./field-templates/properties/date.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/datetime.ng.html',
      require('./field-templates/properties/datetime.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/dropdownlist.ng.html',
      require('./field-templates/properties/dropdownlist.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/email.ng.html',
      require('./field-templates/properties/email.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/fileupload.ng.html',
      require('./field-templates/properties/fileupload.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/formula.ng.html',
      require('./field-templates/properties/formula.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/address.ng.html',
      require('./field-templates/properties/address.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/externalbusiness.ng.html',
      require('./field-templates/properties/externalbusiness.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/image.ng.html',
      require('./field-templates/properties/image.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/instruction.ng.html',
      require('./field-templates/properties/instruction.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/lookup.ng.html',
      require('./field-templates/properties/lookup.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/multiselectlist.ng.html',
      require('./field-templates/properties/multiselectlist.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/number.ng.html',
      require('./field-templates/properties/number.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/password.ng.html',
      require('./field-templates/properties/password.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/radiobuttonlist.ng.html',
      require('./field-templates/properties/radiobuttonlist.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/selectlist.ng.html',
      require('./field-templates/properties/selectlist.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/signature.ng.html',
      require('./field-templates/properties/signature.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/submit.ng.html',
      require('./field-templates/properties/submit.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/table.ng.html',
      require('./field-templates/properties/table.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/tasklist.ng.html',
      require('./field-templates/properties/tasklist.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/recaptcha.ng.html',
      require('./field-templates/properties/recaptcha.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/text.ng.html',
      require('./field-templates/properties/text.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/textarea.ng.html',
      require('./field-templates/properties/textarea.ng.html').default
    );
    $templateCache.put(
      'angular-form-gen/field-templates/properties/procedure.ng.html',
      require('./field-templates/properties/procedure.ng.html').default
    );
  }
]);

//create a namespaced store
fg.factory('flowStore', [
  'store',
  function (store) {
    return store.getNamespacedStore('flow');
  }
]);

/**
 * Constructor for form-gen Field types.
 * @param {string} type         Indicates the type of field
 * @param {object} properties   [optional] Initial property values
 */
fg.constant('FgField', function FgField(type, properties) {
  this.name = this.type = type;

  if (properties) {
    angular.extend(this, properties);
  }

  this.displayName =
    this.displayName ||
    this.type.charAt(0).toUpperCase() + this.type.substring(1);

  this.paletteIcon = this.paletteIcon || 'fa-light fa-square';
});

function fgConfigProvider() {
  const config = {
    //If TRUE displays a dummy done button on forms
    //https://bizflo.atlassian.net/wiki/display/TECH/Angular+Form+Gen
    showDummyDoneButton: true,
    enableDebugInfo: false,
    validation: {
      messages: {},
      patterns: {}
    },
    fields: {
      templates: [],
      categories: {},
      renderInfo: {}
    }
  };

  const templates = config.fields.templates;

  function indexOfTemplate(type) {
    let idx = templates.length;

    while (idx--) {
      if (templates[idx].type === type) {
        break;
      }
    }

    return idx;
  }

  return {
    debug: function (value) {
      config.enableDebugInfo = value;
    },
    setShowDummyDoneButton: function (value) {
      config.showDummyDoneButton = value;
    },
    fields: {
      add: function (
        objectTemplate,
        categories,
        templateUrl,
        propertiesTemplateUrl
      ) {
        if (
          !objectTemplate ||
          !objectTemplate.type ||
          !categories ||
          !categories.length
        ) {
          throw new Error(
            'Need a valid objectTemplate and at least one category'
          );
        }

        const idx = indexOfTemplate(objectTemplate.type);

        if (idx !== -1) {
          templates[idx] = objectTemplate;
        } else {
          templates.push(objectTemplate);
        }

        this.category(objectTemplate.type, categories);
        this.renderInfo(
          objectTemplate.type,
          templateUrl,
          propertiesTemplateUrl
        );
      },
      remove: function (type) {
        const idx = indexOfTemplate(type);

        if (idx !== -1) {
          templates.splice(idx, 1);
        }

        this.category(type);
        this.renderInfo(type);
      },
      renderInfo: function (fieldType, templateUrl, propertiesTemplateUrl) {
        config.fields.renderInfo[fieldType] = {
          templateUrl: templateUrl,
          propertiesTemplateUrl: propertiesTemplateUrl
        };
      },
      category: function (fieldType, categories) {
        if (!angular.isArray(categories)) {
          categories = [categories];
        }

        /*                    angular.forEach(config.fields.categories, function (category) {
                        delete category[fieldType];
                    });*/

        angular.forEach(categories, function (category) {
          if (config.fields.categories[category] === undefined) {
            config.fields.categories[category] = {};
          }

          config.fields.categories[category][fieldType] = true;
        });
      }
    },
    validation: {
      message: function (typeOrObject, message) {
        const messages = config.validation.messages;

        if (angular.isString(typeOrObject)) {
          if (!message) {
            throw new Error('No message specified for ' + typeOrObject);
          }

          messages[typeOrObject] = message;
        } else {
          angular.extend(messages, typeOrObject);
        }
      },
      pattern: function (nameOrObject, pattern) {
        if (angular.isString(nameOrObject)) {
          config.validation.patterns[name] = pattern;
        } else {
          angular.extend(config.validation.patterns, nameOrObject);
        }
      }
    },
    $get: function () {
      return config;
    }
  };
}
fg.provider('fgConfig', fgConfigProvider);

fg.config([
  'fgConfigProvider',
  'FgField',
  function (fgConfigProvider, FgField) {
    // - - - - - - - - - - - - - - - - - - - - - -
    // Messages
    // - - - - - - - - - - - - - - - - - - - - - -

    fgConfigProvider.validation.message({
      required:
        'A {{ field.validationTypeName }} value is required for this field.',
      minlength:
        'The value does not match the minimum length{{ field.schema && (" of " + field.schema.validation.minlength + " characters" || "")}}.',
      /*
       * Originally this is referencing field.schema.validation and not customValidation. Validation is unused
       * now and customValidation is the one that is being heavily used, so we 're going to follow suite
       * and usecustomValidation instead of validation.
       *                                                                           -Cassey
       */
      maxlength:
        'The value exceeds the maximum length{{ field.schema && (" of " + field.schema.customValidation.maxLength + " characters" || "")}}.',
      pattern:
        'The value "{{ field.state.$viewValue }}" does not match the required format.',
      unique: 'The value "{{ field.state.$viewValue }}" is already in use.',
      number: 'The value is not a number.',
      min: 'The value {{ field.schema && ("should be at least " + field.schema.validation.min) || field.state.$viewValue + " is too low" }}',
      max: 'The value {{ field.schema && ("should be less than " + field.schema.validation.max) || field.state.$viewValue + " is too high" }}',
      addressSelection: 'Please select a valid address from the list.',
      businessSelection: 'Please select a valid business from the list.'
    });

    // - - - - - - - - - - - - - - - - - - - - - -
    // Fields
    // - - - - - - - - - - - - - - - - - - - - - -
    const approvalField = new FgField('approvalrule', {
      displayName: 'Approval rule',
      typeName: 'Approval rule',
      paletteIcon: 'fa-light fa-check',
      hideInPalette: true,
      actionButtons: {
        hideSettings: true,
        hideDelete: true
      },
      validation: {
        required: true
      },
      options: [
        {
          value: '1',
          text: 'Approve'
        },
        {
          value: '0',
          text: 'Reject'
        }
      ]
    });
    const attachDocumentField = new FgField('attachdocument', {
      displayName: 'Attach Documents',
      typeName: 'Attach Documents',
      paletteIcon: 'fa-light fa-paperclip',
      nolabel: true,
      validation: {
        required: false
      }
    });
    const checkboxField = new FgField('checkbox', {
      displayName: 'Check box',
      nolabel: true,
      typeName: 'Check box',
      paletteIcon: 'fa-light fa-square-check',
      validation: {
        required: false
      }
    });
    const currencyField = new FgField('currency', {
      displayName: 'Currency',
      typeName: 'Currency',
      paletteIcon: 'fa-light fa-dollar-sign',
      validation: {
        maxlength: 15 /* to prevent > Number.MAX_VALUE */,
        required: true
      }
    });
    const dateField = new FgField('date', {
      displayName: 'Date',
      typeName: 'Date',
      paletteIcon: 'fa-light fa-calendar',
      validation: {
        required: true
      }
    });
    const dateTimeField = new FgField('datetime', {
      typeName: 'Date Time',
      displayName: 'Date Time',
      paletteIcon: 'fa-light fa-calendar-clock',
      validation: {
        required: true,
        messages: {
          required: 'A date time value is required for this field'
        }
      }
    });
    const dropdownListField = new FgField('selectlist', {
      displayName: 'Dropdown list',
      typeName: 'Dropdown list',
      paletteIcon: 'fa-light fa-arrows-up-down',
      validation: {
        required: true
      },
      options: [
        {
          value: '1',
          text: 'Option 1'
        },
        {
          value: '2',
          text: 'Option 2'
        },
        {
          value: '3',
          text: 'Option 3'
        }
      ],
      //default value needs to be emmpty so that our placeholders are used
      value: '',
      searchable: true
    });
    const dynamicActorsField = new FgField('dynamicactors', {
      displayName: 'Select who will be assigned to the next step',
      typeName: 'Dynamic actors',
      paletteIcon: 'fa-light fa-user',
      hideInPalette: true,
      actionButtons: {
        hideSettings: false,
        hideDelete: true
      },
      validation: {
        required: true
      },
      options: []
    });
    const emailField = new FgField('email', {
      displayName: 'Email',
      typeName: 'Email',
      paletteIcon: 'fa-light fa-envelope',
      validation: {
        required: true
      }
    });
    const fileUploadField = new FgField('fileupload', {
      displayName: 'File upload',
      typeName: 'File upload',
      paletteIcon: 'fa-light fa-paperclip',
      nolabel: true,
      validation: {
        required: true
      }
    });
    const formulaField = new FgField('formula', {
      displayName: 'Formula',
      typeName: 'Formula',
      paletteIcon: 'fa-light fa-calculator',
      validation: {}
    });
    const addressField = new FgField('address', {
      displayName: 'Address',
      typeName: 'Address',
      paletteIcon: 'fa-light fa-location-dot',
      validation: {
        required: true
      }
    });
    const externalBusinessField = new FgField('externalbusiness', {
      displayName: 'Business Lookup',
      typeName: 'Business Lookup',
      paletteIcon: 'fa-light fa-building',
      validation: {
        required: true
      },
      subFieldVisibility: {
        entityName: true,
        id: true,
        industryClassificationCode: true,
        industryDescription: true,
        entityStatus: false,
        businessType: false,
        entityType: false,
        registrationDate: false,
        directorInformation: false,
        registeredAddress: false
      }
    });
    const instructionField = new FgField('instruction', {
      displayName: 'Instruction',
      typeName: 'Instruction',
      paletteIcon: 'fa-light fa-message',
      nolabel: true,
      value: 'Enter the instructions to be displayed here.'
    });
    const longTextField = new FgField('textarea', {
      displayName: 'Long text',
      typeName: 'Long text',
      paletteIcon: 'fa-light fa-align-left',
      validation: {
        required: true
      }
    });
    const lookupField = new FgField('lookup', {
      displayName: 'Lookup Field',
      typeName: 'Lookup',
      paletteIcon: 'fa-light fa-magnifying-glass',
      validation: {}
    });
    const multiSelectListField = new FgField('multiselectlist', {
      typeName: 'Multi-selection list',
      displayName: 'Multi-selection list',
      paletteIcon: 'fa-light fa-list',
      validation: {
        required: true,
        messages: {
          required: 'You must select at least 1 item from the list'
        }
      },
      options: [
        {
          value: '1',
          checked: true,
          text: 'Option 1'
        },
        {
          value: '2',
          text: 'Option 2'
        }
      ]
    });
    const numberField = new FgField('number', {
      displayName: 'Number',
      typeName: 'Number',
      paletteIcon: 'fa-light fa-hashtag',
      validation: {
        maxlength: 15 /* to prevent > Number.MAX_VALUE */,
        required: true
      }
    });
    const radioButtonListField = new FgField('radiobuttonlist', {
      displayName: 'Option list',
      typeName: 'Option list',
      paletteIcon: 'fa-light fa-circle-dot',
      validation: {
        required: true
      },
      options: [
        {
          value: '1',
          text: 'Option 1'
        },
        {
          value: '2',
          text: 'Option 2'
        },
        {
          value: '3',
          text: 'Option 3'
        }
      ]
    });
    const recaptchaField = new FgField('recaptcha', {
      displayName: 'ReCaptcha',
      nolabel: true,
      typeName: 'ReCaptcha',
      paletteIcon: 'fa-light fa-shield',
      disabled: false,
      disableUniqueName: true,
      shrunk: true,
      actionButtons: {
        hideSettings: true
      },
      validation: {
        required: true,
        messages: {
          required: 'Complete the reCAPTCHA'
        }
      }
    });
    const shortTextField = new FgField('text', {
      displayName: 'Short text',
      typeName: 'Short text',
      paletteIcon: 'fa-light fa-font',
      validation: {
        required: true
      }
    });
    const signatureField = new FgField('signature', {
      displayName: 'Signature',
      typeName: 'signature',
      paletteIcon: 'fa-light fa-signature',
      nolabel: true,
      validation: {
        required: true
      }
    });
    const tableField = new FgField('table', {
      displayName: 'Table',
      typeName: 'Table',
      paletteIcon: 'fa-light fa-table',
      validation: {
        required: true
      }
    });
    const taskListField = new FgField('tasklist', {
      typeName: 'Task list',
      displayName: 'Task list',
      paletteIcon: 'fa-light fa-list-check',
      validation: {
        required: true,
        messages: {
          required:
            'You must complete all task list items to complete this form'
        }
      },
      options: [
        {
          value: '1',
          checked: true,
          text: 'Task 1'
        },
        {
          value: '2',
          text: 'Task 2'
        }
      ]
    });

    const procedureField = new FgField('procedure', {
      displayName: 'SOP',
      typeName: 'Procedure',
      paletteIcon: 'fa-light fa-file-lines'
    });

    const categories = {
      'Text input fields': [shortTextField, longTextField, fileUploadField],
      'Table fields': [tableField],
      'Select input fields': [
        dropdownListField,
        radioButtonListField,
        approvalField,
        dynamicActorsField
      ],
      'Checkbox fields': [
        checkboxField,
        taskListField,
        multiSelectListField,
        recaptchaField
      ],
      'Other input fields': [
        signatureField,
        currencyField,
        emailField,
        numberField,
        dateField,
        dateTimeField,
        formulaField,
        addressField,
        externalBusinessField
      ],
      'Read-only fields': [
        instructionField,
        attachDocumentField,
        procedureField
      ],
      'Database fields': [
        shortTextField,
        emailField,
        currencyField,
        numberField,
        dropdownListField,
        lookupField,
        tableField
      ]
    };

    //This effectively sorts the fields we see available in the modeler task designer!
    //Search keys (so this can be found): fieldType, field.type, templateType, templates, template
    angular.forEach(categories, function (fields, category) {
      angular.forEach(fields, function (field) {
        fgConfigProvider.fields.add(
          field,
          category /*, templateUrl, propertiesTemplateUrl */
        );
      });
    });

    // - - - - - - - - - - - - - - - - - - - - - -
    // Patterns
    // - - - - - - - - - - - - - - - - - - - - - -

    fgConfigProvider.validation.pattern({
      None: undefined,
      Url: '^(https?:\\/\\/)?([\\da-z\\.-]+)\\.([a-z\\.]{2,6})([\\/\\w \\.-]*)*\\/?$',
      Domain: '^([a-z][a-z0-9\\-]+(\\.|\\-*\\.))+[a-z]{2,6}$',
      'IPv4 Address':
        '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
      'Email Address':
        "/^[a-zA-Z0-9\\-_]+([\\.'+][a-zA-Z0-9\\-_]+)*@[a-z0-9]+(\\-[a-z0-9]+)*(\\.[a-z0-9]+(\\-[a-z0-9]+)*)*\\.[a-z]{2,4}$/i",
      Integer: '^-{0,1}\\d+$',
      'Positive Integers': '^\\d+$',
      'Negative Integers': '^-\\d+$',
      Number: '^-{0,1}\\d*\\.{0,1}\\d+$',
      'Positive Number': '^\\d*\\.{0,1}\\d+$',
      'Negative Number': '^-\\d*\\.{0,1}\\d+$',
      'Year (1920-2099)': '^(19|20)[\\d]{2,2}$',
      Password:
        '(?=.*\\d)(?=.*[!@#$%^&*\\-=()|?."\';:]+)(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$'
    });
  }
]);

export type FgConfigProviderType = ReturnType<typeof fgConfigProvider>;
